// extracted by mini-css-extract-plugin
export default {"row":"W1Kt_Cg0J_ZnkAJ_Cxz7"};